export const permissionTool = {

    isHavePermission(permissonStr, permissionArr) {
        if (permissionArr.indexOf(permissonStr) === -1) {
            return false
        }
        return true
    }

}